import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Button from "../../components/Button/Button";

import classes from "../LinkBox/LinkBox.module.css";

export default function LinkBox() {
  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.head}>
        <div className={classes.title}>
          <Typography component="h6" variant={"h6"}>
            Rapporter
          </Typography>
        </div>
        <div className={classes.text}>
          <Button />
        </div>
      </div>
    </React.Fragment>
  );
}
